import { useLanguage } from '@/context/LanguageContext'
import { DataList, DataListOption } from '@/services/mobi-api/data/types'
import React, { FunctionComponent } from 'react'
import DataCard from './dataCard'
import classNames from 'classnames'

interface Props {
  dataList: DataList[]
  selectedGroup: number
  clickedOption?: DataListOption
  selectPackage: (item: DataListOption) => void
}

const ShowAll: FunctionComponent<Props> = ({ dataList, selectedGroup, clickedOption, selectPackage }) => {
  const { locale } = useLanguage()

  if (dataList === undefined) {
    return <div>404</div>
  }

  return (
    <div className='flex flex-col gap-3 mb-40 lg:mb-24'>
      {
        dataList.slice(1).map((data: DataList, index: number) => (
          <div className='bg-surfaceMid rounded-2xl p-1' key={index}>
            <span className='text-textHigh font-bold text-sm m-3'>
              {locale === 'en' ? data.groupNameEn : data.groupNameMn}
            </span>
            <div className={classNames('gap-2 my-2', data.cardType === 1 ? 'grid grid-cols-2' : 'flex flex-col')}>
              {data.options.map((item, i) => (
                <DataCard key={i} item={item} clickedOption={clickedOption} selectPackage={selectPackage} cardType={data.cardType ?? 1} />
              ))}
            </div>
          </div>
        ))
        }
    </div>

  )
}

export default ShowAll
